import { render, staticRenderFns } from "./MonthLessons.vue?vue&type=template&id=446d7e84&scoped=true"
import script from "./MonthLessons.vue?vue&type=script&lang=js"
export * from "./MonthLessons.vue?vue&type=script&lang=js"
import style0 from "./MonthLessons.vue?vue&type=style&index=0&id=446d7e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446d7e84",
  null
  
)

export default component.exports